<div class="content-body default-height">
    <!-- Breadcrumb  -->
    <app-breadcrumb [breadcrumb]="breadcrumbList" [addProperty]="checkPropertyAdd ? 'Add Property' : ''" (addEvent)="addPropertyEvent($event)"> </app-breadcrumb>
    <div class="container-fluid">
     <div class="card">
       <form [formGroup]="searchForm" autocomplete="off">
        <div class="card-header card-display">
            <div class="row align-items-center w-100">
                <div class="col-md-3 mt-1">
                    <input type="text" class="form-control input-default" placeholder="Name" formControlName="name" />
                </div>
                <div class="col-md-3 mt-1" *ngIf="checkPropertyManagedByFilter">
                  <select2 ngDefaultControl [data]="users" [templates]="template"
                          class="select2" value="" placeholder="Managed by" formControlName="managed_by" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                  </select2>

                </div>
                <div  class="mt-1" [ngClass]="checkPropertyManagedByFilter ? 'col-md-2' : 'col-md-3'" >
                    <select2 ngDefaultControl [data]="cities_list" [templates]="template"
                          class="select2" placeholder="Select city" formControlName="city" (update)="handleSearch('')">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                  </select2>
                </div>
                <div class="mt-1" [ngClass]="checkPropertyManagedByFilter ? 'col-md-2' : 'col-md-3'">
                    <select class="form-select" formControlName="status" (change)="handleSearch('')">
                      <option disabled value="">Status</option>
                        <option value="Work in Progress">Work in Progress</option>
                        <option value="Pending">Pending</option>
                        <option value="Approved">Approved</option>
                        <option value="Archived">Archived</option>
                        <option value="Enquiry">Enquiry</option>
                    </select>
                </div>
                <div class="mt-1" [ngClass]="checkPropertyManagedByFilter ? 'col-md-2' : 'col-md-3'">
                    <ng-select formControlName="category" [items]="categoryOptions" bindLabel="label" bindValue="value"
                        [multiple]="true" [closeOnSelect]="false" placeholder="Category"
                        (change)="handleSearch('')" (clear)="handleSearch('')" class="select2-sm">
                    </ng-select>
                </div>
                <div class="mt-1" [ngClass]="checkPropertyManagedByFilter ? 'col-md-2' : 'col-md-3'">
                    <select class="form-select" formControlName="listing_status" (change)="handleSearch('')">
                      <option value="">Listing Status</option>
                      <option *ngFor="let opt of listingStatusOptions" [value]="opt.value">{{ opt.label }}</option>
                    </select>
                </div>
                <!-- <div class="col-md-2 mt-2">
                    <a class="btn btn-primary btn-sm me-3 mb-3 float-end"  href="javascript:void(0);" (click)="addPropertySearchToggle()">Advanced Search</a>
                </div> -->
              </div>
              <div class="row align-items-center">
                <div class="col-md-12 mt-1">
                  <button class="btn btn-danger btn-sm  mt-3 float-end"  type="button" (click)="resetSearchForm()" [disabled]="!disableClear">Clear</button>
                  <!-- Advanced Search is temporarily hidden (d-none), not removed. -->
                  <a class="btn btn-primary btn-sm me-3 mt-3 float-end d-none"  href="javascript:void(0);" (click)="addPropertySearchToggle()">Advanced Search</a>
                  <a class="btn btn-primary btn-sm me-3 mt-3 float-end"  href="javascript:void(0);" (click)="quickStatsToggle()">Quick Stats</a>
                  <!-- <a class="btn btn-primary btn-sm me-4 mt-3 float-end" href="javascript:void(0);" >Bulk Assign</a> -->
                </div>
              </div>
            </div>
          </form>
     </div>
      <div class="tab-content" id="tabContentMyProfileBottom">
        <div class="row">
          <div class="col-xl-12">
                <div class="card">
                    <div class="card-body">

                      <div class="third-post card-header-line pb-3" *ngIf="!allData.data?.length">
                        <span class="no-property">No Properties Found</span>
                      </div>

                        <div class="table-responsive active-projects style-1 ItemsCheckboxSec shorting dataTables_wrapper" *ngIf="allData.data?.length">
                          <table id="properties-tbl" class="table mb-0">
                            <thead>
                              <tr>
                                <th>Property Name</th>
                                <th>Owner Name</th>
                                <th>Listing Status</th>
                                <th>Category</th>
                                <th>City</th>
                                <th>Status</th>
                                <th class="text-center">Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let property of allData.data">
                                <td>
                                  <a *ngIf="checkPropertyView" href="javascript:void(0);" class="property-name-link" (click)="viewProperty(property.uid, 1)">{{ property.name }}</a>
                                  <span *ngIf="!checkPropertyView">{{ property.name }}</span>
                                </td>
                                <td>{{ property.owner_name || '-' }}</td>
                                <td>{{ property.listing_status || '-' }}</td>
                                <td>{{ property.categories?.length ? property.categories.join(', ') : '-' }}</td>
                                <td>{{ property.city || '-' }}</td>
                                <td>{{ property.status || '-' }}</td>
                                <td class="text-center">
                                  <!-- Action icons: keep the existing buttons -->
                                  <button *ngIf="checkPropertyDetailsTab"
                                          type="button"
                                          class="btn btn-sm btn-outline-primary me-2"
                                          (click)="moveToBills(property.uid, 1)"
                                          title="Property Details">
                                    <i class="fas fa-info-circle"></i>
                                  </button>
                                  <button *ngIf="checkPropertyDocumentsTab"
                                          type="button"
                                          class="btn btn-sm btn-outline-secondary me-2"
                                          (click)="moveToBills(property.uid, 6)"
                                          title="Documents">
                                    <i class="fas fa-file-alt"></i>
                                  </button>
                                  <button *ngIf="checkPropertyBillsTab"
                                          type="button"
                                          class="btn btn-sm btn-outline-success"
                                          (click)="moveToBills(property.uid, 5)"
                                          title="Bills">
                                    <i class="fas fa-file-invoice-dollar"></i>
                                  </button>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">

                          <!-- Left side: showing counts -->
                          <div class="dataTables_info" id="example5_info" role="status" aria-live="polite" *ngIf="allData.data?.length">
                            Showing {{allData.startPage}} to {{allData.endPage}} of {{ totalPage }} entries
                          </div>

                          <!-- Right side: pagination -->
                          <div class="dataTables_paginate paging_simple_numbers pt-2" *ngIf="allData.data?.length">
                            <app-pagination [totalPage]="pageCount" [page]="page" (newPage)="pageChange($event)">
                            </app-pagination>
                          </div>

                        </div>

                    </div>
                </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div #addPropertyButton class="offcanvas offcanvas-end customeoff {{ propertyadd_edit ? 'show':''}}" tabindex="-1" id="propertyadd_edit">
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">Add Property</h5>
      <button type="button" class="btn-close" aria-label="Close"  (click)="propertyClose()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >
      <form [formGroup]="propertyForm" (ngSubmit)="onSubmit()" autocomplete="off">
        <div class="">
            <label>Cover Image</label>
            <div class="dz-default dlab-message upload-img mb-3">
                <div class="dropzone">
                    <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20.5 20V35" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M34.4833 30.6501C36.1088 29.7638 37.393 28.3615 38.1331 26.6644C38.8731 24.9673 39.027 23.0721 38.5703 21.2779C38.1136 19.4836 37.0724 17.8926 35.6111 16.7558C34.1497 15.619 32.3514 15.0013 30.4999 15.0001H28.3999C27.8955 13.0488 26.9552 11.2373 25.6498 9.70171C24.3445 8.16614 22.708 6.94647 20.8634 6.1344C19.0189 5.32233 17.0142 4.93899 15.0001 5.01319C12.9861 5.0874 11.015 5.61722 9.23523 6.56283C7.45541 7.50844 5.91312 8.84523 4.7243 10.4727C3.53549 12.1002 2.73108 13.9759 2.37157 15.959C2.01205 17.9421 2.10678 19.9809 2.64862 21.9222C3.19047 23.8634 4.16534 25.6565 5.49994 27.1667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M27.1666 26.6667L20.4999 20L13.8333 26.6667" stroke="#DADADA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <div class="fallback">
                        <input name="file" type="file" (change)="onImageChange($event)"
                        accept="image/*">

                    </div>
                  </div>
            </div>
        </div>
        <div class="row">
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-1" class="form-label">Property Name<span class="text-danger">*</span></label>
              <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="Villa1" formControlName="name">
              <div *ngIf="propertyForm?.get('name')?.invalid && propertyForm?.get('name')?.touched" class="required">
                Property Name is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-2" class="form-label">Property Type<span class="text-danger">*</span></label>
              <select class="form-select" formControlName="type" placeholder="Villa">
                <option  data-display="Select" value="" selected>Please select</option>
                <option value="House/Villa">House/Villa</option>
                <option value="Commercial Property">Commercial Property</option>
                <option value="Office">Office</option>
                <option value="Retail">Retail</option>
                <option value="Storage">Storage</option>
                <option value="Hospitality">Hospitality</option>
                <option value="Apartment">Apartment</option>
                <option value="Studio">Studio</option>
                <option value="Showroom">Showroom</option>
                <option value="Warehouses">Warehouses</option>
                <option value="Plot &amp; Farmhouse">Plot &amp; Farmhouse</option>
                <option value="multiUnit">Builder Multi Unit</option>
                <option value="pg">Paying Guest</option>
              </select>
              <div *ngIf="propertyForm?.get('type')?.invalid && propertyForm?.get('type')?.touched" class="required">
                Property Type is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-3" class="form-label">Address Line 1<span class="text-danger">*</span></label>
              <input type="email" class="form-control" id="exampleFormControlInput1-3" placeholder="Hyderabad" formControlName="address_1">
              <div *ngIf="propertyForm?.get('address_1')?.invalid && propertyForm?.get('address_1')?.touched" class="required">
                Address is required
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Address Line 2</label>
            <input type="email" class="form-control" id="exampleFormControlInput1-3" placeholder="KDD" formControlName="address_2">
        </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Country<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="countries" [templates]="template"
                          class="select2" placeholder="Select country" formControlName="country" (update)="getStates()">
                          <ng-template #template let-data="data">{{data?.name}}</ng-template>
                  </select2>
              <div *ngIf="propertyForm?.get('country')?.invalid && propertyForm?.get('country')?.touched" class="required">
                Country is required
            </div>
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">State<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="states" [templates]="template"
            class="select2" value="" placeholder="Select state" formControlName="state" (update)="getCities()">
            <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
              <div *ngIf="propertyForm?.get('state')?.invalid && propertyForm?.get('state')?.touched" class="required">
                State is required
            </div>
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">City<span class="text-danger">*</span></label>
            <select2 ngDefaultControl [data]="cities" [templates]="template"
            class="select2" value="" placeholder="Select city" formControlName="city">
            <ng-template #template let-data="data">{{data?.name}}</ng-template>
            </select2>
              <div *ngIf="propertyForm?.get('city')?.invalid && propertyForm?.get('city')?.touched" class="required">
                City is required
            </div>
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Locality<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="HYD" formControlName="locality">
            <div *ngIf="propertyForm?.get('locality')?.invalid && propertyForm?.get('locality')?.touched" class="required">
                Locality is required
          </div>
        </div>

        <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Zipcode<span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="123456" formControlName="postal_code">
            <div *ngIf="propertyForm?.get('postal_code')?.invalid && propertyForm?.get('postal_code')?.touched" class="required">
                <span *ngIf="propertyForm?.get('postal_code')?.errors?.['required']">Zipcode is required</span>
                <span *ngIf="propertyForm?.get('postal_code')?.errors?.['pattern']">Zipcode must be numbers only (5-10 digits)</span>
          </div>
        </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-3" class="form-label">Status<span class="text-danger">*</span></label>
            <select class="form-select" formControlName="listing_status" placeholder="sell">
                <option  data-display="Select" value="" selected>Please select</option>
                <option value="Sell">Sell</option>
                <option value="Sold">Sold</option>
                <option value="Rent Available">Rent Available</option>
                <option value="Rent Occupied">Rent Occupied</option>
                <option value="Property Management">Property Management</option>
                <option value="Tenant Placement">Tenant Placement</option>
                <option value="Plot Monitoring">Plot Monitoring</option>
                <option value="Repairs &amp; Renovation">Repairs &amp; Renovation</option>
                <option value="Documentation">Documentation</option>
            </select>
            <div *ngIf="propertyForm?.get('listing_status')?.invalid && propertyForm?.get('listing_status')?.touched" class="required">
                Status is required
          </div>
          </div>

          <div class="col-xl-12 mb-3">
            <label for="exampleFormControlInput1-1" class="form-label">Project Description<span class="text-danger">*</span></label>
            <textarea class="form-control" id="exampleFormControlInput1-1" placeholder="Description"
              formControlName="description"></textarea>
              <div *ngIf="propertyForm?.get('description')?.invalid && propertyForm?.get('description')?.touched" class="required">
                <small *ngIf="propertyForm?.get('description')?.errors?.['required']">
                  Description is required
                </small>
                <small *ngIf="propertyForm?.get('description')?.errors?.['minlength']">
                  Minimum length is 15 characters.
                </small>
              </div>
          </div>

      </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3"  type="submit" [disabled]="propertyForm.invalid || loadingService.isLoading()">Submit</button>
                  <button class="btn btn-danger lightme-1" type="button" aria-label="Close"  (click)="propertyClose()">Cancel</button>
              </div>
      </form>
        </div>
    </div>
  </div>
  @if(propertyadd_edit){
    <div class="offcanvas-backdrop fade show" (click)="addPropertyToggle()"></div>
  }

  <div #advancedSearchPopup class="offcanvas offcanvas-end customeoff {{ propertyadvanced_search ? 'show':''}}" tabindex="-1" id="propertyadvanced_search" >
    <div class="offcanvas-header">
    <h5 class="modal-title" id="#gridSystemModal">Advanced Search</h5>
      <button type="button" class="btn-close"  aria-label="Close"  (click)="advancedPropertyClose()">
          <i class="fa-solid fa-xmark"></i>
      </button>
    </div>
    <div class="offcanvas-body">
      <div class="container-fluid" >
      <form [formGroup]="advancedSearchForm" (ngSubmit)="advancedSearch()" autocomplete="off">

        <div class="row">
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-1" class="form-label">Min Budegt</label>
              <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="5000" formControlName="budget_min">
          </div>
          <div class="col-xl-6 mb-3">
              <label for="exampleFormControlInput1-2" class="form-label">Max Budegt</label>
              <input type="text" class="form-control" id="exampleFormControlInput1-1" placeholder="5000000" formControlName="budget_max">
              <div *ngIf="advancedSearchForm.controls['budget_max'].hasError('minGreaterThanMax')" class="required">
                Max Budget must be greater than Min Budget.
            </div>
          </div>
          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Rental aggrement end date</label>
            <mat-form-field class="mb-3">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [formGroup]="advancedSearchForm" [rangePicker]="picker">
                  <input matStartDate formControlName="rental_agreement_end_date_start" placeholder="Start date">
                  <input matEndDate formControlName="rental_agreement_end_date_end" placeholder="End date">
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
              </mat-form-field>
          </div>

          <div class="col-xl-6 mb-3">
            <label for="exampleFormControlInput1-2" class="form-label">Owner agreement start date</label>
            <mat-form-field class="mb-3">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [formGroup]="advancedSearchForm" [rangePicker]="picker1">
                  <input matStartDate formControlName="owner_agreement_start_from" placeholder="Start date">
                  <input matEndDate formControlName="owner_agreement_start_to" placeholder="End date">
                </mat-date-range-input>
                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-date-range-picker #picker1></mat-date-range-picker>
              </mat-form-field>
          </div>

      </div>
              <div>
                  <button class="btn btn-primary ms-1 me-3"  type="submit" [disabled]="advancedSearchForm.invalid || loadingService.isLoading()">Search</button>
                  <button class="btn btn-danger lightme-1" type="button" aria-label="Close"  (click)="advancedPropertyClose()">Cancel</button>
              </div>
      </form>
        </div>
    </div>
  </div>
  @if(propertyadvanced_search){
    <div class="offcanvas-backdrop fade show" (click)="addPropertySearchToggle()"></div>
  }

  <!-- Quick Stats modal: record counts by status and category (moved here from below the filters) -->
  <div class="modal d-block" tabindex="-1" role="dialog" *ngIf="quickStatsOpen" style="background-color: rgba(0,0,0,0.5);">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Quick Stats</h5>
          <button type="button" class="btn-close" aria-label="Close" (click)="quickStatsToggle()">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div class="modal-body">
          <h6 class="mb-2">By Status</h6>
          <div class="d-flex flex-wrap gap-2">
            <div *ngFor="let card of statusCards"
                class="status-card"
                [ngClass]="card.bgClass"
                [class.active]="searchForm.get('status')?.value === card.key"
                (click)="onStatusCardClick(card.key)"
                [attr.title]="'Click to filter by ' + card.label">
              <div class="status-value">{{ getStatusCount(card.key) }}</div>
              <div class="status-label">{{ card.label }}</div>
            </div>
          </div>
          <h6 class="mb-2 mt-3">By Category</h6>
          <div class="d-flex flex-wrap gap-2">
            <div *ngFor="let card of categoryCards"
                class="status-card"
                [ngClass]="card.bgClass"
                [class.active]="isCategorySelected(card.key)"
                (click)="onCategoryCardClick(card.key)"
                [attr.title]="'Click to filter by ' + card.label">
              <div class="status-value">{{ getCategoryCount(card.key) }}</div>
              <div class="status-label">{{ card.label }}</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" (click)="quickStatsToggle()">Close</button>
        </div>
      </div>
    </div>
  </div>
